import { useNavigate } from 'react-router-dom';
import BrandsPage from '../../BrandsPage';
import { useLegacyAppSession } from '../../contexts/LegacyAppSessionContext';

export default function BrandsContainer() {
  const navigate = useNavigate();
  const { org, currentUser } = useLegacyAppSession();

  return (
    <BrandsPage
      organizationId={org?.id ?? null}
      currentUser={currentUser}
      onAdd={() => navigate('/brands/new')}
      onEdit={(brand) => navigate(`/brands/${brand.id}/edit`)}
    />
  );
}
